/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface EmbeddingsUsage
 */
export interface EmbeddingsUsage {
    /**
     * 
     * @type {number}
     * @memberof EmbeddingsUsage
     */
    tokenCount?: number;
}

/**
 * Check if a given object implements the EmbeddingsUsage interface.
 */
export function instanceOfEmbeddingsUsage(value: object): boolean {
    return true;
}

export function EmbeddingsUsageFromJSON(json: any): EmbeddingsUsage {
    return EmbeddingsUsageFromJSONTyped(json, false);
}

export function EmbeddingsUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmbeddingsUsage {
    if (json == null) {
        return json;
    }
    return {
        
        'tokenCount': json['tokenCount'] == null ? undefined : json['tokenCount'],
    };
}

export function EmbeddingsUsageToJSON(value?: EmbeddingsUsage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tokenCount': value['tokenCount'],
    };
}

